export const encodedTableColumns = [
    {
      key: "key",
      display_name: "Key",
      cellStyles: {
        "font-size": "13px",
      },
      headerStyles: {
        background: "#7593F2",
        "font-weight": "600",
        width: "50%",
        color: "#fff",
      },
      _editConfig: {
        type: 'input',
        placeholder: 'Add key'
      }
    },
    {
      key: "edit",
      display_name: "",
      cellStyles: { "font-size": "13px" },
      headerStyles: {
        background: "#7593F2",
        "font-weight": "600",
        width: "3%",
        color: "#fff",
      },
      _config: {
        // displayInColumn: false,
        type: "svg-editor",
        value: "../../../../assets/images/virtusa-icons/edit-light.svg",
        isClickable: "true",
        actionType:"edit",
      },
      _editConfig: {
        type: "svg-editor",
        actionType:"add",
        value: "../../../../assets/images/virtusa-icons/tick.svg",
        isClickable: "true",
      }
    },
    {
      key: "delete",
      display_name: "",
      cellStyles: { "font-size": "13px" },
      headerStyles: {
        background: "#7593F2",
        "font-weight": "600",
        width: "3%",
        color: "#fff",
      },
      _config: {
        // displayInColumn: false,
        type: "svg-editor",
        value: "../../../../assets/images/virtusa-icons/delete-light.svg",
        isClickable: "true",
        actionType:"delete",
      },
      _editConfig: {
        type: "svg-editor",
        value: "../../../../assets/images/virtusa-icons/cross.svg",
        isClickable: "true",
        actionType:"cancel",
      }
    },
  ];
  